import { BriefcaseIcon } from "@heroicons/react/outline";

const companyChangesProcesses = [
  {
    id: "officials/sharesholders/authorizedpersons",
    title: "Officials/Shareholders/Authorized Persons",
    description:
      "Initiate a new application with just a few clicks and you will be on your way.",
    icon: <BriefcaseIcon />,
    hash: "officials-shareholders-authorized-person-changes",
  },
  {
    id: "articlesOfAssociation",
    title: "Articles Of Association",
    description:
      "Initiate a new application with just a few clicks and you will be on your way to amend your articles.",
    icon: <BriefcaseIcon />,
    hash: "articles-of-association-changes",
    disabled: true,
  },
  {
    id: "shareCapital",
    title: "Share Capital",
    description:
      "Initiate a new application with just a few clicks and you will be on your way.",
    icon: <BriefcaseIcon />,
    hash: "share-capital-changes",
    disabled: false,
  },
  {
    id: "registeredAddress",
    title: "Registered Address",
    description:
      "Initiate a new application with just a few clicks and you will be on your way.",
    icon: <BriefcaseIcon />,
    hash: "registered-address-changes",
    disabled: true,
  },
  {
    id: "accountReferenceDate",
    title: "Account Reference Date",
    description:
      "Initiate a new application with just a few clicks and you will be on your way.",
    icon: <BriefcaseIcon />,
    hash: "reference-date-changes",
    disabled: true,
  },
  {
    id: "companyConversion",
    title: "Conversion of a company",
    description:
      "Initiate a new application with just a few clicks and you will be on your way.",
    icon: <BriefcaseIcon />,
    hash: "company-conversion-changes",
    disabled: true,
  },
  {
    id: "strikeOff",
    title: "Strike Off",
    description:
      "Initiate a new application with just a few clicks and you will be on your way.",
    icon: <BriefcaseIcon />,
    hash: "strike-off-changes",
    disabled: true,
  },
  {
    id: "bankAccounts",
    title: "Bank Account(s)",
    description:
      "Maintain the particulars of your Bank Account(s) with just a few clicks.",
    icon: <BriefcaseIcon />,
    hash: "bank-accounts-changes",
    disabled: true,
  },
  {
    id: "companyName",
    title: "Name of a company",
    description:
      "Initiate a new application with just a few clicks and you will be on your way.",
    icon: <BriefcaseIcon />,
    hash: "company-name-changes",
    disabled: true,
  },
];

const COMPANY_PROCESSES = {
  CHANGES: {
    id: "changes",
    title: "Changes",
    description:
      "Initiate a new change application with just a few clicks and you will be on your way.",
    icon: <BriefcaseIcon />,
    hash: "company-changes",
    children: companyChangesProcesses,
  },
  ANNUAL_RETURNS: {
    id: "annual-compliance",
    title: "Annual Compliance",
    description:
      "Initiate the auto-generation of your Annual Compliance for signature and filing with the Registrar of Companies.",
    icon: <BriefcaseIcon />,
    hash: "annual-compliance",
  },
  REVIEW_APPLICATION: {
    id: "reviewApplication",
    title: "Review Application",
    description:
      "Initiate transaction of existing business operations or ownership to Simple Formation Limited",
    icon: <BriefcaseIcon />,
    hash: "review-application",
  },
  SIGNATURE_APPLICATION: {
    id: "signatureApplication",
    title: "Signature Application",
    description:
      "Initiate transaction of existing business operations or ownership to Simple Formation Limited",
    icon: <BriefcaseIcon />,
    hash: "signature-application",
  },
  DRAFT_APPLICATION: {
    id: "draftApplication",
    title: "Draft Application",
    description:
      "Initiate transaction of existing business operations or ownership to Simple Formation Limited",
    icon: <BriefcaseIcon />,
    hash: "draft-application",
  },
  CORRECTION_APPLICATION: {
    id: "correctionApplication",
    title: "Correction Application",
    description:
      "Initiate transaction of existing business operations or ownership to Simple Formation Limited",
    icon: <BriefcaseIcon />,
    hash: "correction-application",
  },
  UPDATE_COMPANY_DETAILS: {
    id: "updateCompanyDetails",
    title: "Update Company Details",
    description:
      "Initiate transaction of existing business operations or ownership to Simple Formation Limited",
    icon: <BriefcaseIcon />,
    hash: "update-company-details",
  },
};

const GENERATE_TABS = ({
  generalInformationCommentsCount,
  residentialDetailsCommentsCount,
  fileUploadCommentsCount,
  changeDocumentsCommentsCount,
}) => {
  const INITIAL_TABS = [
    { id: "assignOfficials", label: "Assign Officials" },
    {
      id: "generalInformation",
      label: "General Information",
      commentsCount: generalInformationCommentsCount,
    },
    {
      id: "residentialDetails",
      label: "Address Details",
      commentsCount: residentialDetailsCommentsCount,
    },
    {
      id: "uploadDocuments",
      label: "KYC Documents",
      commentsCount: fileUploadCommentsCount,
    },
    {
      id: "uploadChangeDocuments",
      label: "Change Documents",
      commentsCount: changeDocumentsCommentsCount,
    },
  ];
  const SHORT_FORM_TABS = [
    { id: "assignOfficials", label: "Assign Officials" },
    {
      id: "generalInformation",
      label: "General Information",
      commentsCount: generalInformationCommentsCount,
    },
    {
      id: "uploadDocuments",
      label: "Upload Documents",
      commentsCount: fileUploadCommentsCount,
    },
  ];
  const LONG_FORM_TABS = [
    { id: "assignOfficials", label: "Assign Officials" },
    {
      id: "generalInformation",
      label: "General Information",
      commentsCount: generalInformationCommentsCount,
    },
    {
      id: "residentialDetails",
      label: "Address Details",
      commentsCount: residentialDetailsCommentsCount,
    },
    {
      id: "uploadDocuments",
      label: "Upload Documents",
      commentsCount: fileUploadCommentsCount,
    },
  ];
  const APPLICATION_CORRECTION_TABS = [
    {
      id: "generalInformation",
      label: "General Information",
      commentsCount: generalInformationCommentsCount,
    },
    {
      id: "residentialDetails",
      label: "Address Details",
      commentsCount: residentialDetailsCommentsCount,
    },
    {
      id: "uploadDocuments",
      label: "KYC Documents",
      commentsCount: fileUploadCommentsCount,
    },
    {
      id: "uploadChangeDocuments",
      label: "Change Documents",
      commentsCount: changeDocumentsCommentsCount,
    },
  ];
  const MANAGE_MODULE_EDIT_TABS = [
    {
      id: "generalInformation",
      label: "General Information",
      commentsCount: generalInformationCommentsCount,
    },
    {
      id: "residentialDetails",
      label: "Address Details",
      commentsCount: residentialDetailsCommentsCount,
    },
    {
      id: "uploadDocuments",
      label: "KYC Documents",
      commentsCount: fileUploadCommentsCount,
    },
    {
      id: "uploadChangeDocuments",
      label: "Change Documents",
      commentsCount: changeDocumentsCommentsCount,
    },
    {
      id: "uploadDirectorApprovalDocuments",
      label: "Director Approval Documents",
      commentsCount: changeDocumentsCommentsCount,
    },
  ];
  return {
    INITIAL_TABS,
    SHORT_FORM_TABS,
    LONG_FORM_TABS,
    APPLICATION_CORRECTION_TABS,
    MANAGE_MODULE_EDIT_TABS,
  };
};

export { COMPANY_PROCESSES, GENERATE_TABS };
